<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { createEventDispatcher, onMount } from 'svelte';

    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import { jobs, planning } from '../../../stores/store';
    import IconBack from '../../shared/Icons/IconBack.svelte';
    import type { JobResponseType } from './types';
    import { jobInitialData } from './jobInitialData';
    import JobEditForm from './JobEditForm.svelte';
    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import { JobResponseSchema } from './types';
    import { Job } from './Job';
    import { MapPointLocation } from '../../utilities/MapPointLocation';
    import { onMapReady } from '../../utilities/onMapReady';
    import { JobOnMap } from './JobOnMap';
    import { api } from '../../../stores/api';
    import { JobApi } from './JobApi';
    import { BalloonContentGenerator } from './BalloonContentGenerator';
    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import { Navigation } from '../../utilities/Navigation';
    import Spinner from '../../shared/Spinner/Spinner.svelte';

    export let id: number|null = null;

    let job: Job = new Job();
    let mapPointLocation: MapPointLocation | null = null;
    let dispatch = createEventDispatcher();
    let jobOnMap: JobOnMap = new JobOnMap();
    let jobGeocodedOnMap: JobOnMap = new JobOnMap();
    let triedToSave: boolean = false;

    let loading: boolean = true;
    let error: string|null = null;

    function prepareNewJob() {
        console.log('prepareNewJob()');
        let jobResponse: JobResponseType = JobResponseSchema.parse({
            ...jobInitialData(1, -2, 1),
            updated: '2020-01-01 00:00:00',
            created: '2020-01-01 00:00:00',
            coords_accepted: false,
            id: -1,
            newly_added: true,
            collection_id: 1,
            target_date: $planning.selectedDay === '' ? null : $planning.selectedDay,
            coords_set_manually: false,
            special_attributes: {
                ...jobInitialData(1, -2, 1).special_attributes,
                parcels: 1,
                delivery_or_collection: 'delivery',
                earliest_delivery_date: null, //$planning.selectedDay,
                latest_delivery_date: null, // $planning.selectedDay,
                /*start_of_time_window: '08:00',
                end_of_time_window: '16:00',*/
                total_weight: 0,
                fill_percentage: 0,
            },
        });
        triedToSave = false;
        job.set(JSON.parse(JSON.stringify(jobResponse)));
        job.getData().id = -1;
        job = job;
    }

    function tryToUseRevGeoDetails(revGeoDetails) {
        if (jobOnMap) jobOnMap.clear();
        if (revGeoDetails) {
            job.updateAddressAttributeValue('pcode', revGeoDetails.postcode);
            job.updateAddressAttributeValue('city', revGeoDetails.city);
            job.updateAddressAttributeValue('country', revGeoDetails.country);
            job.updateAddressAttributeValue('street', revGeoDetails.street);
            job.updateAddressAttributeValue('house', revGeoDetails.house);
            job.updateAddressAttributeValue('province', revGeoDetails.province);
            job.updateAddressAttributeValue('quarter', revGeoDetails.quarter);
            job.updateAddressAttributeValue('community', revGeoDetails.community);

            // job.getData().address_attributes.pcode = revGeoDetails.postcode;
            // job.getData().address_attributes.city = revGeoDetails.city;
            // job.getData().address_attributes.country = revGeoDetails.country;
            // job.getData().address_attributes.street = revGeoDetails.street;
            // job.getData().address_attributes.house = revGeoDetails.house;
            // job.getData().address_attributes.province = revGeoDetails.province;
            // job.getData().address_attributes.quarter = revGeoDetails.quarter;
            // job.getData().address_attributes.community = revGeoDetails.community;
            // job.getData().address_attributes.community = revGeoDetails.community;
            // job.getData().geom = {
            //     type: 'Point',
            //     coordinates: [revGeoDetails.x, revGeoDetails.y]
            // };
            job.setCoords(revGeoDetails.x, revGeoDetails.y, true);
            job.getData().address_id =
                revGeoDetails?.house_geoId && revGeoDetails?.house_geoId != ''
                    ? parseInt(revGeoDetails?.house_geoId)
                    : null;
            // job.getData().coords_accepted = true;
            let balloonHtml = new BalloonContentGenerator(job).getBalloonHtmlArray().join('');
            // jobOnMap.addPoint(revGeoDetails.x, revGeoDetails.y, '#334455', 'Adres');
            jobOnMap.addPoint(revGeoDetails.x, revGeoDetails.y, '#334455', balloonHtml);
            jobOnMap.centerMap();
            job = job;
        }
    }

    let startPointOnMap = function () {
        if (mapPointLocation) {
            if (!mapPointLocation.isCurrent()) {
                if (
                    mapPointLocation.start({
                        message: $_('Click on the map to set job #{count} coordinates', {
                            values: { count: job.id },
                        }),
                    })
                ) {
                    // dispatch('pointonmapstart');
                    console.log('pointonmapstart');
                }
            } else {
                mapPointLocation.close(true);
            }
        }
    };

    export const closePointOnMap = function () {
        if (mapPointLocation) {
            if (mapPointLocation.close(true)) {
                console.log('pointonmapclose');
            }
        }
    };

    async function onUpdate() {
        closePointOnMap();
        console.log('jobRequest, before parse', job);
    }

    onMount(() => {
        Promise.all([
            id ? JobApi.getOneWithColumnAssignments($api, id) : null,
            onMapReady()
        ]).then((response) => {
            if (id && response[0]) {
                if (response[0].process_stage < 20) {
                    job.set(response[0]);
                } else {
                    throw new Error('job_cannot_be_changed_due_to_process_stage');
                }
            } else {
                prepareNewJob();
                tryToUseRevGeoDetails($jobs.revGeoDetails);
                $jobs.revGeoDetails = null;
            }
            mapPointLocation = new MapPointLocation();
            mapPointLocation.addEventListener('setCoordinates', function (evt: any) {
                let x = evt.detail.coords.x;
                let y = evt.detail.coords.y;
                let balloonHtml = '-Adres-';
                console.log('setcoordinates', { type: 'Point', coordinates: [x, y] });
                job.setCoords(x, y, true);
                job = job;
                JobApi.revgeo($api, x, y)
                    .then(res => {
                        job.updateAddressAttributeValue('pcode', res.postcode);
                        job.updateAddressAttributeValue('city', res.city);
                        job.updateAddressAttributeValue('country', res.country);
                        job.updateAddressAttributeValue('street', res.street);
                        job.updateAddressAttributeValue('house', res.house);
                        job.updateAddressAttributeValue('province', res.province);
                        job.updateAddressAttributeValue('quarter', res.quarter);
                        job.updateAddressAttributeValue('community', res.community);
                        job.getData().address_id =
                            res?.house_geoId && res?.house_geoId != ''
                                ? parseInt(res?.house_geoId)
                                : null;
                        job = job;
                        balloonHtml = new BalloonContentGenerator(job)
                            .getBalloonHtmlArray()
                            .join('');
                        jobOnMap.addPoint(x, y, '#334455', balloonHtml);
                        jobOnMap.centerMap();
                    })
                    .catch(err => {
                        console.log('revgeo error', err);
                    });
            });
            mapPointLocation.addEventListener('close', function () {
                dispatch('pointonmapclose');
            });
            job = job;
        }).catch(err => {
            error = err.message;
        }).finally(() => {
            loading = false;
        });

        return () => {
            if (mapPointLocation) mapPointLocation.close(true);
        };
    });
</script>

<TemplateStandard>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header">
                <div style="display: flex; align-items: center;min-height: 36px;">
                    <IconBack
                        scale={0.7}
                        on:click={() => {
                            window.history.back();
                        }}
                    />
                    {$_(id ? 'Edit job' : 'Manual add job')}
                </div>
            </div>
            <div slot="main-buttons" style="display:flex; align-items: center; column-gap: 25px;">
                {#if !id}
                    <ButtonAddSomething
                        text={$_('Add job')}
                        on:click={() => {
                            prepareNewJob();
                        }}
                    />
                {/if}
            </div>
        </TemplateHeaderDuo>
    </div>
    <div slot="content-header"></div>
    <div slot="content" style="display: flex; flex-direction: column; overflow-y: auto;">
        {#if loading}
            <Spinner/>
        {:else if error}
            <MessageDanger message={error} onClose={() => { setTimeout(() => { Navigation.navigate('/'); }, 0); }} />
        {:else}
            <JobEditForm
                bind:job
                {startPointOnMap}
                bind:jobOnMap
                bind:jobGeocodedOnMap
                bind:triedToSave
            />
        {/if}
    </div>
    <div slot="footer"></div>
</TemplateStandard>

<style>
</style>
